/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_LabelInputs */

const en_palette_label = /** @type {(inputs: Palette_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search and commands`)
};

/**
* | output |
* | --- |
* | "Search and commands" |
*
* @param {Palette_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const palette_label = /** @type {((inputs?: Palette_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_palette_label(inputs)
});